import React, { FC } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { Customers } from '../customers/Customers';
import { EditCustomer } from './EditCustomer';
import { AddCustomer } from './AddCustomer';

export const CustomersRouter: FC = (props) => {

  const { path } = useRouteMatch();

  return (<Switch>
    <Route exact path={path}>
      <Customers/>
    </Route>
    <Route path={`${path}/add`}>
      <AddCustomer/>
    </Route>
    <Route path={`${path}/:id`}>
      <EditCustomer/>
    </Route>
  </Switch>);
};
